import { generateKeyPair, type KeyPair } from 'dpop';
import { exportJWK } from 'jose';

const alg = 'ES256';

let cachedKeyPair: KeyPair | undefined = undefined;

/**
 * Erzeugt einmal ein ES256 Keypair und hält es NUR in Memory.
 * Kein localStorage, keine Persistenz.
 */
export const getOrCreateKeyPair = async (): Promise<KeyPair> => {
    if (cachedKeyPair) {
        return cachedKeyPair;
    }
    const { privateKey, publicKey } = await generateKeyPair(alg);
    cachedKeyPair = { privateKey, publicKey };
    return cachedKeyPair;
};

/**
 * Public JWK exportieren, um es an /auth/access-token als dpopPublicKeyJwk zu senden.
 */
export const getPublicJwk = async () => {
    const { publicKey } = await getOrCreateKeyPair();
    const jwk = await exportJWK(publicKey);
    jwk.alg = alg;
    jwk.use = 'sig';
    return jwk;
};
